export default {"src":"/_next/static/media/circleExclamationMarkUiRedWithLightBg_40.e2a5c411.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};